import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_3 = { class: "mt-2 text-sm text-gray-600" }
const _hoisted_4 = { class: "mt-6 flex flex-wrap justify-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createBlock($setup["TransitionRoot"], {
    as: "template",
    show: $props.open
  }, {
    default: _withCtx(() => [
      _createVNode($setup["Dialog"], {
        as: "div",
        class: "relative z-50",
        onClose: $setup.close
      }, {
        default: _withCtx(() => [
          _createVNode($setup["TransitionChild"], {
            as: "template",
            enter: "ease-out duration-200",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-150",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-gray-500/75" }, null, -1 /* CACHED */)
            ])),
            _: 1 /* STABLE */,
            __: [0]
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode($setup["TransitionChild"], {
                as: "template",
                enter: "ease-out duration-200",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-150",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode($setup["DialogPanel"], { class: "w-full max-w-md rounded-lg bg-white p-6 shadow-xl" }, {
                    default: _withCtx(() => [
                      _createVNode($setup["DialogTitle"], { class: "text-lg font-semibold text-gray-800" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($props.title), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createElementVNode("p", _hoisted_3, _toDisplayString($props.description), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_UiButton, {
                          variant: "white",
                          "text-variant": "primary",
                          onClick: $setup.close
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('whatsappMeta.confirmDialog.cancel')), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_UiButton, {
                          variant: "danger",
                          "text-variant": "white",
                          disabled: $props.isSubmitting,
                          onClick: $setup.confirm
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($props.confirmLabel), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["disabled"])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show"]))
}